// Bridges the Lenis instance so any component can trigger smooth anchor scrolls.
let lenisInstance = null;

export const setLenis = (l) => {
  lenisInstance = l;
};

export const scrollToId = (id) => {
  const target = id === "top" ? 0 : `#${id}`;
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -70, duration: 1.2 });
  } else {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }
};
